import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';

import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_PRODUCTS_SUCCESS,
    REORDER_PRODUCTS_SUCCESS,
    RESET_PRODUCTS,
    RESET_QUESTIONS,
    RESET_ANSWERS,
    RESET_SUB_QUESTIONS,
    RESET_SUB_ANSWERS,
    LOAD_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS,
    IS_PRODUCT_COPY,
    PRODUCT_COPY,
    IS_PRODUCT_EDIT,
    RESET_PRODUCT_COPY
} from '../../types';
import { convertStringToBoolean, convertNotEmptyStringToNumber } from "../../../utils/CommonUtils";

export const loadProducts = (categoryId, saveInMenuProductCategoryReducer) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        doLoadProducts(dispatch, getState, categoryId, saveInMenuProductCategoryReducer);
    }
}

const doLoadProducts = (dispatch, getState, categoryId, saveInMenuProductCategoryReducer) => {
    const url = `/category-draft/${categoryId}/products`;

    axios().get(url)
        .then(response => saveInMenuProductCategoryReducer ? loadProductsInMenuCategoryProductReducer(dispatch, response) : loadProductsSuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadProductsFailure')));
}

const loadProductsInMenuCategoryProductReducer = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS, payload: response.data });
}

const loadProductsSuccess = (dispatch, response, saveMessageSuccess, publishMessageSuccess, stateId, formData, getState) => {
    // console.log('loadProductsSuccess formData ', formData);
    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        if (formData !== null) {
            // console.log('loadProductsSuccess formData !== null ', formData);
            doUploadProductImage(stateId, formData, dispatch, getState);
        } else {
            MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.saveProductSuccess'));
        }
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.publishProductSuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_QUESTIONS });
    dispatch({ type: RESET_ANSWERS });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_PRODUCTS_SUCCESS, payload: response.data });
}

export const saveProduct = (state, restaurantId, formData, saveProductCallbackOnSuccess, publishProductCallback, deleteImageArgument) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        const {
            id,
            categoryDraftId,
            name,
            description,
            minimumQuantity,
            maximumQuantity,
            active,
            mealDeal,
            sizeName,
            freeToppingsCount,
            sizePriority,
            imageUrl,
            multipleActivateOrDeactivate,
            multipleDescriptionChange,
            multipleNameChange,
            multipleSizeChange,
            allergens,
            dietaryInfo,
            nutrients,
            taxBand,
            secondaryTaxBand,
            productAvailableAllDay,
            availableTimes,
            productOrderTypes,
            currentCategoryDraftId,
            deposit,
            price,
            cookTime,
            disableNotes,
            snoozeValue,
            originProductId,
            availabilityDays } = state;
        const productId = id === -1 ? '' : id;

        const queryParams = originProductId ? `?originProductId=${originProductId}` : ''
        const url = `/product-draft/${productId}${queryParams}`;
        
        if (!state.productAvailableAllDay && !state.availableTimes.length && !availabilityDays.length) {

            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:menusActions.noOpeningHours'));
            return;
        }
        let modifiedNutrients = [];
        nutrients.map(nutri => {
            let nutriObj = {
                nutrition: {
                    id: nutri.id,
                    nutritionCode: nutri.nutritionCode
                },
                value: nutri.value
            };

            modifiedNutrients.push(nutriObj);
        });
        
        let productData = {
            restaurantId: Number(restaurantId),
            categoryDraftId: categoryDraftId,
            name: name,
            description: description,
            minimumQuantity: !convertNotEmptyStringToNumber(minimumQuantity) ? '' : convertNotEmptyStringToNumber(minimumQuantity),
            maximumQuantity: !convertNotEmptyStringToNumber(maximumQuantity) ? '' : convertNotEmptyStringToNumber(maximumQuantity),
            active: convertStringToBoolean(active),
            mealDeal: convertStringToBoolean(mealDeal),
            sizeName: sizeName,
            freeToppingsCount: (freeToppingsCount === "" || freeToppingsCount === null) ? null : Number(freeToppingsCount),
            sizePriority: !convertNotEmptyStringToNumber(sizePriority) ? '' : convertNotEmptyStringToNumber(sizePriority),
            imageUrl: imageUrl,
            multipleActivateOrDeactivate: convertStringToBoolean(multipleActivateOrDeactivate),
            multipleDescriptionChange: convertStringToBoolean(multipleDescriptionChange),
            multipleNameChange: convertStringToBoolean(multipleNameChange),
            multipleSizeChange: convertStringToBoolean(multipleSizeChange),
            allergens: allergens,
            dietaryInfo: dietaryInfo,
            nutrients: modifiedNutrients,
            taxBand: taxBand.id ? taxBand : null,
            secondaryTaxBand: secondaryTaxBand.id ? secondaryTaxBand : null,
            productAvailableAllDay: productAvailableAllDay,
            availableTimes: availableTimes,
            orderTypes: productOrderTypes,
            price: price,
            deposit: deposit,
            cookTime: cookTime,
            disableNotes : disableNotes,
            inactiveTimePeriod: snoozeValue && snoozeValue !== 'custom' ? snoozeValue : null,
            availabilityDays: availabilityDays ? availabilityDays : []
        };

        let currCategoryDraftId = id === -1 ? categoryDraftId : currentCategoryDraftId;

        if (id !== -1) {
            axios().put(url, productData)
                .then(response => saveProductSuccess(dispatch, response, currCategoryDraftId, id, formData, getState, saveProductCallbackOnSuccess, publishProductCallback, deleteImageArgument))
                .catch(error => saveProductFailure(dispatch, error));
        } else {
            axios().post(url, productData)
                .then(response => saveProductSuccess(dispatch, response, currCategoryDraftId, id, formData, getState, saveProductCallbackOnSuccess, publishProductCallback, deleteImageArgument))
        }
    }
}

const saveProductSuccess = (dispatch, response, categoryDraftId, stateId, formData, getState, saveProductCallbackOnSuccess, publishProductCallback, deleteImageArgument) => {
    if (publishProductCallback) {
        doUploadProductImage(stateId, formData, dispatch, getState, publishProductCallback);
        return;
    } else if (!publishProductCallback && saveProductCallbackOnSuccess) {
        saveProductCallbackOnSuccess();
    } else if (!formData && !saveProductCallbackOnSuccess && !publishProductCallback && deleteImageArgument) {
        deleteProductImage(dispatch, getState, stateId, () => {
            deleteImageArgument();
            doLoadProducts(dispatch, getState, categoryDraftId);
        });
        return;
    }

    if (formData) {
        doUploadProductImage(response.data.id, formData, dispatch, getState, () => doLoadProducts(dispatch, getState, categoryDraftId));
    } else {
        doLoadProducts(dispatch, getState, categoryDraftId);
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.saveProductSuccess'));
};

const saveProductFailure = (dispatch, error) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, error.response.data);
}

export const publishProduct = (state) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/product-draft/${state.id}/publish`;

        let categoryDraftId = state.categoryDraftId;

        axios().put(url, {})
            .then(response => publishProductSuccess(dispatch, response, categoryDraftId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.publishProductFailure')))
    }
}

const publishProductSuccess = (dispatch, response, categoryDraftId) => {
    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {
        const url = `/category-draft/${categoryDraftId}/products`;

        axios().get(url)
            .then(response => loadProductsSuccess(dispatch, response, false, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadProductsFailure')));
    }
}

export const reorderProducts = (products, categoryId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/category-draft/${categoryId}/products/reorder`;

        axios().put(url, products)
            .then(response => reorderProductsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.reorderItemsFailure')));
    }
}

const reorderProductsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_PRODUCTS_SUCCESS, payload: response.data });
}

export const resetProducts = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: RESET_PRODUCTS });
    }
}

export const uploadProductImage = (productId, formData) => {
    return (dispatch, getState) => {
        doUploadProductImage(productId, formData, dispatch, getState);
    }
}

const doUploadProductImage = (productId, formData, dispatch, getState, callback) => {
    if (formData) {
        let url = '';
        if (getState().serviceSettingsGeneral.enableLargeImageDesign) {
            url = `/product-draft/${productId}/upload-rectangular-main-image`;
        } else {
            url = `/product-draft/${productId}/upload-main-image`;
        }

        const header = { headers: { 'Content-Type': 'multipart/form-data' } };
        const newFormData = new FormData();
        newFormData.append('file', formData);

        axios().put(url, newFormData, header)
            .then(response => uploadProductImageSuccess(dispatch, response, callback))
            .catch(error => uploadProductImageFailure(dispatch, error));
    } else {
        callback();
    }

}

const uploadProductImageSuccess = (dispatch, response, callback) => {
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.saveProductSuccess'));
}

const uploadProductImageFailure = (dispatch, error) => {
    MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:productsActions.uploadImageFailure'));
}

const deleteProductImage = (dispatch, getState, productId, callback) => {
    let url = '';
    if (getState().serviceSettingsGeneral.enableLargeImageDesign) {
        url = `/product-draft/${productId}/delete-rectangular-main-image`; 
    } else {
        url = `/product-draft/${productId}/delete-main-image`;
    }

    axios().put(url, {})
        .then(response => deleteProductImageSuccess(dispatch, response, callback))
        .catch((error, dispatch) => MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.deletingImageFailure')));
};

const deleteProductImageSuccess = (dispatch, response, callback) => {
    if (callback) {
        callback();
    }

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:productsActions.deletedImageSuccess'));
};

export const isProductCopy = (boolean) => {
    return (dispatch) => {

        dispatch({ type: IS_PRODUCT_COPY, payload: boolean });
    }
}

export const saveProductCopy = (productCopy) => {
    return (dispatch) => {

        dispatch({ type: PRODUCT_COPY, payload: productCopy })
    }
}

export const isProductEdit = (boolean) => {
    return (dispatch) => {

        dispatch({ type: IS_PRODUCT_EDIT, payload: boolean });
    }
}

export const resetProductCopy = () => {
    return (dispatch) => {

        dispatch({ type: RESET_PRODUCT_COPY })
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/ProductsActions.js